module.exports = __webpack_public_path__ + "media/images/pic/brodno/brodno_headmaster-fa4325a9ad0b7daaeed3e349db34e1ec.svg";